import PageHeader from 'common/components/PageHeader';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const ContentCanvas = styled.div`
  padding: ${({ $compact }) => ($compact ? '24px 16px 48px' : '48px 20px 96px')};

  @media (max-width: 640px) {
    padding: ${({ $compact }) =>
      $compact ? '16px 12px 40px' : '28px 16px 64px'};
  }
`;

export const ContentCard = styled.article`
  max-width: ${({ width }) => width || '900px'};
  margin: 0 auto;
  padding: ${({ $compact }) => ($compact ? '24px 18px' : '48px')};
  color: ${themeGet('colors.headingColor')};
  background: ${themeGet('colors.surface')};
  border: 1px solid ${themeGet('colors.borderColor')};
  border-radius: 16px;
  box-shadow: ${themeGet('colors.cardShadow')};

  @media (max-width: 640px) {
    padding: ${({ $compact }) => ($compact ? '20px 16px' : '28px 20px')};
  }

  h2 {
    margin: 40px 0 14px;
    color: ${themeGet('colors.headingColor')};
    font-size: clamp(20px, 2.2vw, 25px);
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: -0.2px;
  }

  h2:first-child {
    margin-top: 0;
  }

  h3 {
    margin: 28px 0 12px;
    font-size: 18px;
    font-weight: 700;
  }

  p,
  li {
    color: ${themeGet('colors.textColorAlt')};
    font-size: 16px;
    line-height: 1.75;
  }

  p {
    margin-bottom: 16px;
  }

  ul,
  ol {
    margin: 0 0 22px;
    padding-left: 24px;
  }

  li {
    margin-bottom: 10px;
    list-style: inherit;
  }

  strong {
    color: ${themeGet('colors.headingColor')};
    font-weight: 700;
  }

  a:not([class]) {
    color: ${themeGet('colors.headingColor')};
    font-weight: 700;
    text-decoration: underline;
    text-decoration-color: ${themeGet('colors.secondaryDark')};
    text-decoration-thickness: 2px;
    text-underline-offset: 3px;
  }
`;

const ContentPage = ({
  children,
  description,
  eyebrow,
  title,
  width,
  compact = false,
}) => (
  <>
    <PageHeader
      title={title}
      description={description}
      eyebrow={eyebrow}
      compact={compact}
    />
    <ContentCanvas $compact={compact}>
      <ContentCard width={width} $compact={compact}>
        {children}
      </ContentCard>
    </ContentCanvas>
  </>
);

ContentPage.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  eyebrow: PropTypes.string,
  title: PropTypes.string.isRequired,
  width: PropTypes.string,
  compact: PropTypes.bool,
};

export default ContentPage;
